export const INPUT_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  EMAIL: 'email',
  TEL: 'tel',
  DATE: 'date',
  MONEY: 'money',
  BOOLEAN: 'boolean',
  MARKDOWN: 'markdown',
  SELECT: 'select',
  TEXT_AREA: 'textArea',
  PHONE: 'phone',
  LINK: 'link',
  PERCENTAGE: 'percentage',
  HIDDEN: 'hidden',
  TIME: 'time',
  TIER_SELECT: 'tierSelect',
};
